(function () {
    'use strict';
    angular.module('app').controller('PaymentGatewayModalController', PaymentGatewayModalController);
    PaymentGatewayModalController.$inject = [
        'PaymentGatewayService',
        '$q',
        'toastr',
        '$uibModalInstance',
        'data'
    ];

    function PaymentGatewayModalController(
        PaymentGatewayService,
        $q,
        toastr,
        $uibModalInstance,
        data
    ) {
        const vm = this;
        vm.paymentGatewayDetails = {};
        vm.preloadedData = data;

        vm.getSupportedPaymentGateway = getSupportedPaymentGateway;
        vm.setParameter = setParameter;
        vm.closeModal = closeModal;
        vm.savePaymentGatewayDetails = savePaymentGatewayDetails;

        init();

        function init() {
            vm.loading = true;
            getSupportedPaymentGateway().then(response => {
                if(vm.preloadedData) {
                    vm.paymentGatewayDetails.paymentGateway = response.find(item => item.appId === vm.preloadedData.appId);
                    vm.paymentGatewayDetails.enabled = vm.preloadedData.enabled;
                    vm.paymentGatewayDetails.parameters = vm.preloadedData.parameters;
                }
                vm.loading = false;
            });
        }

        function getSupportedPaymentGateway(selected) {
            const deffer = $q.defer();
            PaymentGatewayService.PaymentGateway.supportedPaymentGateway(data => {
                vm.paymentMethods = data;
                deffer.resolve(data);
            }, error => {
                toastr.error(error.message, 'Error');
                deffer.reject(error);
            });
            return deffer.promise;
        }

        function setParameter(paymentGateway) {
            vm.paymentGatewayDetails.parameters = paymentGateway.parameters;
        }

        function savePaymentGatewayDetails() {
            const payload = generatePayload();
            if(vm.preloadedData) {
                updatePaymentGatewayDetails(payload);
            } else {
                createNewPaymentGateway(payload);
            }
        }

        function updatePaymentGatewayDetails(payload) {
            vm.isSaving = true;
            PaymentGatewayService.PaymentGateway.updatePaymentGatewayDetails(data => {
                toastr.success('Payment Gateway Updated', 'Success');
                $uibModalInstance.close(data);
                vm.isSaving = false;
            }, error => {
                toastr.error(error.message, 'Error');
                vm.isSaving = false;
            }, vm.preloadedData.id, payload)
        }

        function createNewPaymentGateway(payload) {
            vm.isSaving = true;
            PaymentGatewayService.PaymentGateway.createPaymentGateway(data => {
                toastr.success('Payment Gateway Added', 'Success');
                $uibModalInstance.close(data);
                vm.isSaving = false;
            }, error => {
                toastr.error(error.message, 'Error');
                vm.isSaving = false;
            }, payload);
        }

        function generatePayload() {
            return {
                appId: vm.paymentGatewayDetails.paymentGateway.appId,
                enabled: vm.paymentGatewayDetails.enabled,
                parameters: vm.paymentGatewayDetails.parameters.map(data => {
                    return {
                        name: data.name,
                        value: data.value
                    }
                })
            };
        }

        function closeModal() {
            $uibModalInstance.dismiss();
        }
    }
})();



// WEBPACK FOOTER //
// ./js/controllers/client/modals/PaymentGatewayModalController.js